import { render } from "./UpdateProfile.vue?vue&type=template&id=185fa26e"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=185fa26e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__